export default __webpack_public_path__ + "static/media/Maithili_book3_m.a82f4bb5.wav";